import throttle from 'lodash/throttle'

const SELECTORS = Selectors({
  searchDateForm: 'spotlight-search-date',
  searchYear: 'spotlight-search-year',
  searchMonth: 'spotlight-search-month',
  searchDateSubmit: 'spotlight-search-date button',
  images: 'spotlight-item__images'
})

const props = {
  $searchDateForm: document.querySelector(SELECTORS.asClass('searchDateForm')),
  $searchYear: document.querySelector(SELECTORS.asClass('searchYear')),
  $searchMonth: document.querySelector(SELECTORS.asClass('searchMonth')),
  $searchDateSubmit: document.querySelector(SELECTORS.asClass('searchDateSubmit')),
  $images: document.querySelectorAll(SELECTORS.asClass('images')),
  defaultUrl: '',
  yearsMonthsMap: {}
}

const fn = {
  init: () => {
    props.defaultUrl = props.$searchDateForm.dataset.defaultUrl
    props.yearsMonthsMap = JSON.parse(props.$searchMonth.dataset.months)
    fn.bindEvents()
    fn.repositionImages()

    const selectedYear = props.$searchYear.value
    const selectedMonth = props.$searchMonth.dataset.selected

    if (selectedYear) {
      fn.updateMonth(selectedYear, selectedMonth)
    }
  },

  bindEvents: () => {
    props.$searchYear.addEventListener('change', fn.handleYear)
    props.$searchDateForm.addEventListener('submit', fn.handleDateSubmit)
    window.addEventListener('resize', throttle(fn.repositionImages, 250))
  },

  handleYear: (e) => {
    const selected = e.target.value

    if (selected === '') {
      fn.redirect(props.defaultUrl)
      return
    }

    fn.updateMonth(selected)
  },

  handleDateSubmit: (e) => {
    e.preventDefault()

    const selectedYear = props.$searchYear.value
    const selectedMonth = props.$searchMonth.value
    const formUrl = props.$searchDateForm.action

    const url = `${formUrl}${selectedYear}/${selectedMonth}`

    fn.redirect(url)
  },

  updateMonth: (year, month = false) => {
    const months = props.yearsMonthsMap[year]

    props.$searchMonth.disabled = false
    props.$searchDateSubmit.disabled = false

    let newOptions = '<option data-placeholder>Month</option>'

    for (const monthNum of Object.keys(months)) {
      const monthName = months[monthNum]
      newOptions += `<option value="${monthNum}">${monthName}</option>`
    }

    props.$searchMonth.innerHTML = newOptions

    if (month) {
      props.$searchMonth.value = month
    }
  },

  repositionImages: () => {
    props.$images.forEach(($el) => {
      const $parent = $el.parentNode

      if (window.matchMedia('(min-width: 1024px)').matches) {
        $el.style.top = `${$parent.offsetHeight + 5}px`
      } else {
        $el.style.removeProperty('top')
      }
    })
  },

  redirect: (url) => {
    window.location.href = url
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-volunteerspotlightpage'),
  run: fn.init
}
